import { useField } from 'formik'
import { Ref, useCallback } from 'react'
import { Checkbox as AntdCheckbox } from '../../Checkbox'
import type { CheckboxGroupProps as AntdCheckboxGroupProps } from '../../Checkbox'
import type { FormikFieldProps } from '../typings/FieldProps'

export type CheckboxGroupProps = FormikFieldProps &
  AntdCheckboxGroupProps & {
    ref?: Ref<HTMLDivElement>
  }

export const Group = ({
  name,
  onChange: onChangeProp,
  ...restProps
}: CheckboxGroupProps) => {
  const [field, , helpers] = useField(name)
  const { value } = field
  const { setValue, setTouched } = helpers

  const handleChange = useCallback(
    (value: any) => {
      setValue(value)
      setTouched(true)
      onChangeProp?.(value)
    },
    [onChangeProp, setTouched, setValue]
  )

  return (
    <AntdCheckbox.Group
      name={name}
      value={value}
      onChange={handleChange}
      {...restProps}
    />
  )
}
